<template>
  <div>
    <table
      :height="this.windowSize.height - 8"
      :max-height="this.windowSize.height - 8"
      style="position: absolute"
      width="100%"
    >
      <tr height="48px" max-height="48px">
        <ContenidoBase
          :EstadoBtn="EstadoBtn"
          :descripcion="'Imprime los Vales de Cajas Generados en el Punto de ventas'"
          :titulo="'Relación de Vales de Cajas'"
          @MethodAnular="anular"
          @MethodEliminar="remove"
          @MethodGuardar="save"
          @MethodImprimir="imprimirList"
          @MethodNuevo="newwnuevo"
          @abrirBarraTablaDinamica="abrirTabla"
        />
      </tr>

      <tr>
        <!-- BarraPrimaria --------------------------------------------------------------------------------->
        <td v-show="BarraTablaDinamicaAprir" :max-height="this.windowSize.height - 96" width="109">
          <div
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', width: '325px' }"
          >
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <center>
                  <v-btn-toggle>
                    <v-btn color="yellow accent-4" small @click.prevent="actualiza_tb_ver">
                      <i class="fa fa-eye" style="font-size: 25px"></i>
                      ver
                    </v-btn>
                    <v-btn
                      color="deep-purple accent-2"
                      dark
                      small
                      @click.prevent="notifi('Seguro que desea nuevo', 'n')"
                    >
                      <i class="fa fa-print" style="font-size: 25px"></i>
                      Listado
                    </v-btn>
                  </v-btn-toggle>
                </center>
                <!-- <BarraBusqueda2
              :url="
                $hostname + $hName + '/services/tipocliente/findalltipoclientes'
              "
              :nombre="'Tipo de Clientes'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitReportesRValesCajas'"
              :SeachNombre="'Búsqueda por descripcion '"
              :slotlist="slotlist"
            /> -->
              </template>
            </v-tooltip>
          </div>
        </td>
        <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height - 96">
          <v-app
            id="inspire"
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }"
          >
            <!-- Formulario-Relacion de Vales de Cajas -->
            <v-container>
              <v-card color="grey lighten-3">
                <v-toolbar color="#BDBDBD" dense flat style="border: 1px solid #000000">
                  <v-avatar size="45" tile>
                    <img alt="Reporte" src="@/assets/iconos_micromarket/custom-reports.png" />
                  </v-avatar>
                  <span class="font-weight-light" style="font-size: 20px">Relación de Vales de Cajas</span>

                  <!-- <v-toolbar-title    class="font-weight-light"> Reporte Producción de boletos por unidades</v-toolbar-title > -->
                  <!-- style="color:white;" -->
                  <!-- <i class=""> </i> -->

                  <!-- <v-spacer></v-spacer> -->
                  <!-- <v-btn
          color="grey darken-4"
          fab
          small
          @click="cerrarmodalcuenta"
        >
         <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
        </v-btn> -->
                </v-toolbar>

                <hr />

                <v-container style="border: 1px solid #000000">
                  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="">
                    <v-row>
                      <!-- columna 1 -->
                      <v-col cols="12" md="6" sm="6">
                        <!-- -----------------------------  desde  -->
                        <v-text-field
                          v-model="RValesCajas.desde"
                          :rules="[$rules.required]"
                          dense
                          label="Desde:"
                          outlined
                          type="date"
                          @blur="BlurDesde"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>

                        <!------------------------------------------- caja-->

                        <v-combobox
                          v-model="RValesCajas.caja"
                          :items="RCaja"
                          :rules="[$rules.required]"
                          autocomplete="off"
                          dense
                          item-text="descripcion"
                          label="Caja"
                          outlined
                          required
                          @blur="SelctCbCaja"
                          @focus="cargarCaja"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-cube" style="font-size: 20px"></i>
                          </template>
                        </v-combobox>

                        <v-switch
                          v-model="RValesCajas.mostrarAnulados"
                          class="mt-0"
                          color="teal"
                          hide-details
                          inset
                          label="Mostrar anulados"
                          style="margin-left: 2rem"
                        >
                          <template v-slot:label>
                            <p class="my-auto"><Strong style="color: black">Mostrar anulados</Strong></p>
                          </template>
                        </v-switch>
                      </v-col>
                      <!-- fn columna 1 -->

                      <!-- columna 2 -->
                      <v-col cols="12" md="6" sm="6">
                        <!-- -----------------------------  Hasta  -->
                        <v-text-field
                          v-model="RValesCajas.hasta"
                          :rules="[$rules.required]"
                          dense
                          label="Hasta:"
                          outlined
                          type="date"
                          @blur="BlurHasta"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="RValesCajas.cierre"
                          :rules="[$rules.required]"
                          autocomplete="off"
                          dense
                          label="# Cierre:"
                          outlined
                          type="number"
                          @blur="BlurCierre"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-hashtag" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>
                      </v-col>
                      <!-- fn columna 2 -->
                    </v-row>
                  </v-form>
                </v-container>

                <hr />

                <ModalReporteFiltros :Datos="RValesCajas" @DataReporteBasico="DDataReporteBasico" />
              </v-card>
            </v-container>
            <!-- Formulario-Relacion de Vales de Cajas -->
          </v-app>
        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td v-show="BarraSecundariaAprir" :max-height="this.windowSize.height - 96" width="109">
          <div
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', width: '325px' }"
          >
            <!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
          </div>
        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->
      </tr>
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ tb-data-->
    <v-dialog
      v-model="acti_tb_data"
      label="myAlert"
      max-height="100%"
      max-width="100%"
      persistent
      transition="fab-transition"
    >
      <v-card>
        <v-toolbar color="#BDBDBD" flat>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"></i>
          <v-toolbar-title class="font-weight-light">REPORTE</v-toolbar-title>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"></i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="acti_tb_data = !acti_tb_data">
            <i class="fa fa-close" style="font-size: 20px; color: #dd4b39"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="search" hide-details label="Buscar" single-line @keyup="filtro">
                <template v-slot:prepend-inner>
                  <i class="fa fa-search" style="font-size: 35px"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table :headers="slotHtabla" :items="list" :search="search" dense @click:row="datostabla">
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog v-model="Elim_notif.estado" label="myAlert" max-width="350" persistent transition="fab-transition">
      <template v-slot:activator="{ on }" justify="center"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i class="fa fa-warning" style="font-size: 28px"></i>
            CONFIRMACION
            <i class="fa fa-warning" style="font-size: 28px"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn small @click.prevent="eliminar(), (Elim_notif.estado = !Elim_notif.estado)">
            <i class="fa fa-check" style="font-size: 20px"></i>
            Si
          </v-btn>

          <v-btn small @click.prevent="Elim_notif.estado = !Elim_notif.estado">
            <i class="fa fa-ban" style="font-size: 20px"></i>
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      :timeout="120000"
      :vertical="true"
      style="margin-top: 20%"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
  import { EventBus } from "../../event-bus"
  import BarraBusqueda2 from "../../components/BarraBusquedaDinam"
  import ContenidoBase from "../../components/ContenidoBase"
  import ModalReporteFiltros from "../../components/ModalReporteFiltros"
  import {
    currencyFormatter,
    fechaNueva,
    FormatoFecha,
    getParamFecha,
    HoraFormatter,
    HoraFormatter2,
    RedondeoBasico,
    RedondeoValor,
    RedondeoValorCantRed,
  } from "@/js/Funciones.js"

  export default {
    components: {
      BarraBusqueda2,
      ContenidoBase,
      ModalReporteFiltros,
    },
    created() {
      var json = {
        titulo: "Relación de Vales de Cajas",
        descripcion: "Imprime los Vales de Cajas Generados en el Punto de ventas",
        save: false,
        eliminar: false,
        anular: false,
        nuevo: false,
        imprimir: false,
        accion: [
          "ReportesRValesCajasNew",
          "ReportesRValesCajasSave",
          "ReportesRValesCajasRemove",
          "ReportesRValesCajasAnular",
          "ReportesRValesCajasPrintList",
        ],
      }
      EventBus.$emit("anularBotonesAccion", json)
    },
    mounted() {
      EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
      // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
      // EventBus.$on("ReportesRValesCajasNew", this.new);
      // EventBus.$on("ReportesRValesCajasSave", this.save);
      // EventBus.$on("ReportesRValesCajasRemove", this.remove);
      // EventBus.$on("ReportesRValesCajasAnular", this.remove);
      // EventBus.$on("ReportesRValesCajasPrintList", this.imprimirList);
      EventBus.$on("emitReportesRValesCajas", this.datostabla)

      EventBus.$on("onResize", this.onResize)
    },

    data: () => ({
      Rpropietario: [],
      RSucursal: [],
      RCaja: [],

      ListaTiposClientes: [],
      windowSize: { width: "auto", height: "auto" },
      RValesCajas: {
        nombre: "RELACIÓN DE VALES DE CAJAS",
        UrlImprimir: "/reportes-pv/ImprimirListValesCajas",
        UrlExel: "/reportes-pv/ExcelListValesCajas",
        UrlCorreo: "/reportes-pv/CorreoListValesCajas",
        desde: fechaNueva(),
        hasta: fechaNueva(),
        cierre: null,
        caja: null,
        sucursal: null,
        mostrarAnulados: false,
        //fechaCreacion: new,
        //  fechaModificacion: "",
      },

      EstadoBtn: {
        BarraTablaDinamicaAprir: false,
        nuevo: false,
        guardar: false,
        eliminar: false,
        anular: false,
        imprimir: false,
        vercuenta: false,
        guardartemporal: false,
        restaurartemporal: false,
        importarDato: false,
        cargarProducto: false,
        ImprimirproductoInv: false,
      },

      text: "",
      valid: true,
      BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,

      headers: [{ text: "Tipo Clientes", value: "descripcion" }],

      slotlist: [
        { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
        {
          dt0: "descripcion",
          dt1: null,
          dt2: null,
          dt3: 1,
          dt4: "Descripcion:",
        },
        { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
      ],

      slotHtabla: [
        { text: "Código", value: "codigo" },
        { text: "Descripcion", value: "descripcion" },
      ],

      list: [],
      search: "",
      acti_tb_data: false,
      Elim_notif: {
        estado: false,
        nombre: "¿Seguro que desea anular este registro?",
      },

      aalert: {
        estado: false,
        color: null,
      },
    }),

    //   destroyed() {
    //     location.reload();
    //   },
    methods: {
      currencyFormatter,
      FormatoFecha,
      HoraFormatter,
      HoraFormatter2,
      RedondeoValor,
      RedondeoBasico,
      RedondeoValorCantRed,
      fechaNueva,
      getParamFecha,

      onResize(e) {
        console.log("imprii ")

        console.log(e)
        this.windowSize = e
      },

      abrirTabla() {
        this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir
      },

      datostabla(e) {
        this.RValesCajas = e
        this.acti_tb_data = false
      },
      save() {},
      remove() {},
      eliminar() {},
      anular() {},
      imprimirList() {},
      DDataReporteBasico() {},
      newwnuevo() {
        ;(this.RValesCajas = {
          activo: true,
          borrado: false,
          codigo: 0,
          descripcion: "",
          descripcionOriginal: "",
          fechaCreacion: "",
          fechaModificacion: "",
          usuarioCreacion: "",
          usuarioModificacion: "",
        }),
          EventBus.$emit("actualizaBarraBusqueda2")
      },

      // Llamar a la API y obtener los datos de la API.
      cargarCaja() {
        var headers = this.$store.getters.GetheadersAxios
        this.$axios.get(this.$hostname + this.$hName + "/cajas/findAllActivos", { headers: headers }).then((res) => {
          this.RCaja = res.data
        })
      },

      cargarSucursal() {
        this.$axios
          .post(this.$hostname + this.$hName + "/services/sucursal/findall", {
            usuario: JSON.parse(JSON.stringify(this.$user)),
          })
          .then((res) => (this.RSucursal = res.data))
      },

      SelctCbSucursal() {
        if (this.RValesCajas.sucursal == null) {
          this.RValesCajas.sucursal = ""
        }

        if (this.RValesCajas.sucursal.codigo == undefined) {
          this.alerta("Seleccione un sucursal", "error")
          this.RValesCajas.sucursal = ""
          return
        }
      },

      // Comprobando si el usuario ha seleccionado un valor del menú desplegable. Si no, está mostrando
      // un mensaje de error.
      SelctCbCaja() {
        if (this.RValesCajas.caja == null) {
          this.RValesCajas.caja = ""
        }

        if (this.RValesCajas.caja.codigo == undefined) {
          this.alerta("Seleccione un caja", "error")
          this.RValesCajas.caja = ""
          return
        }
      },

      // Al verificar si la longitud de la cadena es 0, si lo es, está configurando el valor en nulo.
      BlurCierre() {
        if (this.RValesCajas.cierre.toString().length == 0) {
          this.RValesCajas.cierre = null
        }
      },

      // Al verificar si la longitud de la cadena es 0, si lo es, está configurando la fecha a la fecha de
      // hoy.
      BlurDesde() {
        if (this.RValesCajas.desde.toString().length == 0) {
          this.RValesCajas.desde = new Date().toISOString().substr(0, 10)
        }
      },

      // Un método que se llama cuando el usuario abandona el campo de
      //entrada y si la fecha es nula coloca la de el dia actual.
      BlurHasta() {
        if (this.RValesCajas.hasta.toString().length == 0) {
          this.RValesCajas.hasta = new Date().toISOString().substr(0, 10)
        }
      },

      alerta(e, l) {
        if (l == "bien") {
          ;(this.aalert.estado = true), (this.aalert.color = "success"), (this.aalert.nombre = e)

          this.newwnuevo()
        }

        if (l == "error") {
          ;(this.aalert.estado = true), (this.aalert.color = "error"), (this.aalert.nombre = e)

          this.ejecucion = false
        }
      },

      actualiza_tb_ver() {
        this.acti_tb_data = !this.acti_tb_data
        this.filtro()
      },

      async filtro() {},
    },
  }
</script>

<style></style>
